import { Box, Button, IconButton } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import {
  useUtils,
  useNextMonthDisabled,
  usePreviousMonthDisabled,
} from "@mui/x-date-pickers/internals";

// Calendar header with separate Month and Year buttons (replaces MUI's single "October 2026 ▾" toggle).
// Registered globally for every DatePicker in theme.js.
const SplitCalendarHeader = ({
  currentMonth,
  onMonthChange,
  onViewChange,
  view,
  views,
  disabled,
  disableFuture,
  disablePast,
  minDate,
  maxDate,
  timezone,
}) => {
  const utils = useUtils();
  const isNextDisabled = useNextMonthDisabled(currentMonth, { disableFuture, maxDate, timezone });
  const isPrevDisabled = usePreviousMonthDisabled(currentMonth, { disablePast, minDate, timezone });

  // Clicking the active button returns to the picker's final view (day, or month for month pickers)
  const toggle = (target) => onViewChange?.(view === target ? views[views.length - 1] : target);

  const viewButton = (target, label) =>
    views.includes(target) && (
      <Button
        size="small"
        disabled={disabled || views.length === 1}
        onClick={() => toggle(target)}
        endIcon={<ArrowDropDownIcon sx={{ transform: view === target ? "rotate(180deg)" : "none" }} />}
        sx={{
          textTransform: "none",
          fontSize: "1rem",
          fontWeight: 500,
          color: "text.primary",
          bgcolor: view === target ? "action.selected" : "transparent",
          px: 1,
          minWidth: 0,
        }}
      >
        {label}
      </Button>
    );

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 2, mb: 1, px: 2 }}>
      <Box sx={{ display: "flex", gap: 0.5 }}>
        {viewButton("month", utils.format(currentMonth, "month"))}
        {viewButton("year", utils.format(currentMonth, "year"))}
      </Box>
      {view === "day" && (
        <Box>
          <IconButton
            size="small"
            aria-label="Previous month"
            disabled={disabled || isPrevDisabled}
            onClick={() => onMonthChange(utils.addMonths(currentMonth, -1), "right")}
          >
            <ChevronLeftIcon />
          </IconButton>
          <IconButton
            size="small"
            aria-label="Next month"
            disabled={disabled || isNextDisabled}
            onClick={() => onMonthChange(utils.addMonths(currentMonth, 1), "left")}
          >
            <ChevronRightIcon />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default SplitCalendarHeader;
